import { useState } from "react";

import { Search, Select, GradientButton } from "../../components/forms";
import { PageContainer } from "../../components/PageComponents";
import { CountryIcon } from "../../assets/Icons";
import { Promotion, PromotionModal } from "./components";

const Promotions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <PageContainer title="Promotions">
      <div className="row-4">
        <Search
          placeholder="Search by promotion name"
          onChange={() => {
            // Handle search input change
          }}
        />
        <Select icon={<CountryIcon />} options={countrydata} type="filter" />
        <Select options={statusData} type="filter" />
        <GradientButton
          content="Add new promo"
          onClick={() => setModalOpen(!modalOpen)}
        />
      </div>

      <Promotion promotions={promotionData} />
      {modalOpen && <PromotionModal close={() => setModalOpen(!modalOpen)} />}
    </PageContainer>
  );
};

export default Promotions;

export const countrydata = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
];

export const statusData = ["Expired", "Ongoing"];

const promotionData = [
  {
    id: 1,
    name: "First Time Purchase",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Ongoing",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
  {
    id: 2,
    name: "Nigeria Sale Week",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Ongoing",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
  {
    id: 3,
    name: "First Time Purchase",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Expired",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
];
